import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './card.json';import texture from './card.png';export default new Aseprite(texture, data);